var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFanOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.998,
    height: 17,
    viewBox: "0 0 15.998 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fan_OFF",
    "data-name": "Fan OFF",
    d: "M14.12,10.164l-3.44-.84a2.077,2.077,0,0,0-.76-.16,1.773,1.773,0,0,0-.07-1.509,2.19,2.19,0,0,0,.72-.13l3.47-.67a2.261,2.261,0,0,0,1.9-1.819,4.346,4.346,0,0,0,.06-.85A5.674,5.674,0,0,0,15.11,1.1,2.111,2.111,0,0,0,13.69.01a1.034,1.034,0,0,0-.8.27A12,12,0,0,0,9.36,6.236a2.245,2.245,0,0,0-.14.71,1.914,1.914,0,0,0-.89-.29,2.2,2.2,0,0,0-.71.15,2.452,2.452,0,0,0-.13-.67L6.83,2.649A2.258,2.258,0,0,0,5.02.74,4.414,4.414,0,0,0,4.17.68a5.658,5.658,0,0,0-3.08.9A2.111,2.111,0,0,0,.01,3.008a1.068,1.068,0,0,0,.27.81A11.93,11.93,0,0,0,6.21,7.366a2.407,2.407,0,0,0,.6.14,1.787,1.787,0,0,0-.3.9,1.721,1.721,0,0,0,.24.889,2.313,2.313,0,0,0-.7.13l-3.47.67a2.261,2.261,0,0,0-1.9,1.819,4.454,4.454,0,0,0-.06.86,5.7,5.7,0,0,0,.89,3.088A2.11,2.11,0,0,0,2.93,16.95a1.034,1.034,0,0,0,.8-.27,12,12,0,0,0,3.53-5.957,2.137,2.137,0,0,0,.14-.74,1.728,1.728,0,0,0,.87.26,1.8,1.8,0,0,0,1-.34,2.66,2.66,0,0,0,.12.65,12.051,12.051,0,0,0,3.23,6.127,1.079,1.079,0,0,0,.79.32,2.134,2.134,0,0,0,1.47-1.019,5.661,5.661,0,0,0,1.04-3.038,4.839,4.839,0,0,0-.01-.86A2.173,2.173,0,0,0,14.12,10.164Z",
    transform: "translate(-0.002 -0.002)",
    fill: "#6a7084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFanOff);
export default __webpack_public_path__ + "static/media/fan_off.613d23bfafb93c5985d65a2a77aa42a0.svg";
export { ForwardRef as ReactComponent };